import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import React from 'react';
import { SvgIcon } from '@material-ui/core';
import styled from 'styled-components';
var StyledIcon = styled(SvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var palette = _ref.theme.palette;
  return "\n    fill: ".concat(palette.primary.contrastText, ";\n  ");
});

var ArrowUpward = function ArrowUpward() {
  return React.createElement(StyledIcon, null, React.createElement("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
  }));
};

export default ArrowUpward;